import { EventNames, globalEventBus } from '@littlebird/event-bus';
import { useEffect } from 'react';

import { router } from '@/router';
import { trackEvent } from '@/utils/analytics';

export const useAnalytics = () => {
  useEffect(() => {
    const unsubscribe = router.subscribe('onBeforeRouteMount', (state) => {
      trackEvent('PAGE_VIEWED', { pagename: state.toLocation.pathname });
    });
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const sub = globalEventBus.on(
      EventNames.ANALYTICS_TRACK_MESSAGE_RESPONSE_EVENT,
      ({ data }) => {
        trackEvent('LITTLEBIRD_CHAT_RESPONSE', data);
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const sub = globalEventBus.on(
      EventNames.ANALYTICS_TRACK_MESSAGE_ERROR_EVENT,
      ({ data }) => {
        trackEvent('MESSAGE_ERROR', data);
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);
};
